import { site } from "../data/content";

// Renders the REConsultX wordmark with the "X" in an accent colour.
export default function Brand({ className = "", size = "md" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-3xl md:text-4xl",
    xl: "text-5xl md:text-6xl",
  };
  const [main, last] = [site.brand.slice(0, -1), site.brand.slice(-1)];
  return (
    <span className={`font-serif tracking-tight leading-none ${sizes[size] || sizes.md} ${className}`}>
      <span style={{ color: "var(--primary)" }}>{main}</span>
      <span style={{ color: "var(--accent)", fontWeight: 700, fontStyle: "italic" }}>{last}</span>
    </span>
  );
}
